import {
    SET_SELECTED_COMPONENT_ID, SET_EQUIPMENTS, SET_ONGOING_EDIT_GLOBALLY, UPDATE_SENSOR_INFORMATION,
    MAXIMIZE_OR_MINIMIZE_IMAGE_SECTION, DESELECT_COMPONENT, SET_EQUIPMENT_DETAIL_LOADING,
    REMOVE_ALL_PERSISTED_DATA, UPDATE_EQUIPMENT_INFORMATION, UPDATE_COMPONENT_INFORMATION, ADD_NEW_SENSOR,
    SET_ALL_EQUIPMENTS_AND_PROFILE_ACCESSIBILITY, REMOVE_DETACHED_SENSOR, ROTATE_COMPONENT_IMAGE,
    ROTATE_EQUIPMENT_IMAGE, ADD_CLONED_EQUIPMENT, SET_SELECTED_COMPONENT_DETAILS, SET_COMPONENT_LOADING,
    DESELECT_EQUIPMENT, UPDATE_EQUIPMENT_UNIT_FOUNDATION, UPDATE_EQUIPMENT_UNIT_CLASS, ADD_NEW_BEARING,
    SET_EQUIPMENT_UNIT_CLASSES_LIST, UPDATE_CATEGORY_INFO, REMOVE_CATEGORY_FROM_EQUIPMENT_UNIT,
    UPDATE_EQUIPMENT_UNIT_NAME, UPDATE_COMPONENT_NAME, UPDATE_EQUIPMENT_UNIT_POSITIVE_DISPLACEMENT,
    REMOVE_BEARING
} from "../actions"
import _ from "lodash";

const initialState = {
    isEditOngoing: false,
    isLockedProfile: false,
    currentEnlargedImageType: "",
    showEnlargedImage: false,
    selectedComponent: {},
    currentEquipmentUnits: [],
    equipmentLoading: false,
    equipmentPictures: {},
    allEquipments: [],
    componentLoading: false,
    equipmentUnitClasses: []
}

const equipmentReducer = (state = initialState, { type, payload }) => {

    let updatedComponentInfo = {}, updatedEquipmentUnits = {}, updatedEquipmentsList = [];

    const returnUpdatedEquipmentUnitInfo = (deletedComponentNames, newOrRestoredComponents) => {
        updatedEquipmentUnits = _.cloneDeep(state.currentEquipmentUnits);
        if(!_.isEmpty(deletedComponentNames) || !_.isEmpty(newOrRestoredComponents)) {
            let updatedComponentsList = updatedEquipmentUnits[payload?.equipmentUnitName]?.components;

            if(!_.isEmpty(deletedComponentNames)) {
                updatedComponentsList = updatedComponentsList.filter(component => !deletedComponentNames.includes(component.name));
            }

            if(!_.isEmpty(newOrRestoredComponents)) {
                updatedComponentsList = [ ...updatedComponentsList, ...newOrRestoredComponents ];
            }
            
            updatedEquipmentUnits[payload?.equipmentUnitName].components = updatedComponentsList;
        }
        return updatedEquipmentUnits;
    }

    const returnUpdatedEquipmentList = (equipmentUnits) => {
        updatedEquipmentsList = _.cloneDeep(state.allEquipments);
        for(let ind = 0; ind < updatedEquipmentsList.length; ind++) {
            if(updatedEquipmentsList[ind].id === payload.equipmentId) {
                updatedEquipmentsList[ind].isCategoryNotAppliedEquipment = 
                    Object.values(equipmentUnits).filter(equipmentUnit => _.isEmpty(equipmentUnit.appliedCategoryName)).length > 0;
            }
        }
        return updatedEquipmentsList;
    }

    switch (type) {

        case DESELECT_EQUIPMENT:
            return { ...state, selectedComponent: {}, currentEquipmentUnits: [], equipmentPictures: {} };

        case SET_COMPONENT_LOADING:
            return { ...state, componentLoading: payload };

        case SET_SELECTED_COMPONENT_DETAILS:
            return { ...state, selectedComponent: _.cloneDeep(payload), componentLoading: false };

        case ADD_CLONED_EQUIPMENT:
            let updatedList = _.cloneDeep(state.allEquipments);
            updatedList.splice(payload.index + 1, 0, payload.equipmentData);
            return { ...state, allEquipments: updatedList };

        case ROTATE_EQUIPMENT_IMAGE:
            let updatedEquipmentPictures = _.cloneDeep(state.equipmentPictures);
            updatedEquipmentPictures[payload.id] = payload.link;
            return { ...state, equipmentPictures: updatedEquipmentPictures };

        case ROTATE_COMPONENT_IMAGE:
            let imageUpdatedComponentInfo = _.cloneDeep(state.selectedComponent);
            if(!_.isEmpty(imageUpdatedComponentInfo?.componentPictures[payload.id])) {
                imageUpdatedComponentInfo.componentPictures[payload.id] = payload.link;
            }
            else {
                imageUpdatedComponentInfo.labelPictures[payload.id] = payload.link;
            }
            return { ...state, selectedComponent: imageUpdatedComponentInfo };

        case ADD_NEW_SENSOR:
            updatedComponentInfo = _.cloneDeep(state.selectedComponent);
            const sensorObj = {
                id: payload.id,
                metadata: payload.metadata,
                installLocation: payload.location,
                bearingInformation : payload.bearingInformation
            };
            if(!_.isEmpty(updatedComponentInfo?.sensors)) {
                updatedComponentInfo.sensors.push(sensorObj);
            }
            else {
                updatedComponentInfo.sensors = [sensorObj]
            }
            return { ...state, selectedComponent: updatedComponentInfo, isEditOngoing: false };


        case REMOVE_DETACHED_SENSOR:
            let detachedSensorInd;
            updatedComponentInfo = _.cloneDeep(state.selectedComponent);
            updatedComponentInfo.sensors.forEach((sensor, ind) => {
                if(sensor.id === payload) {
                    detachedSensorInd = ind;
                }
            });
            updatedComponentInfo.sensors.splice(detachedSensorInd, 1);
            return { ...state, selectedComponent: updatedComponentInfo };

        case UPDATE_EQUIPMENT_INFORMATION:
            updatedEquipmentsList = _.cloneDeep(state.allEquipments);
            updatedEquipmentsList.forEach((equipment) => {
                if(equipment.id === payload.id) {
                    equipment.location = payload.location;
                    equipment.name = payload.name
                }
            });
            return { ...state, allEquipments: updatedEquipmentsList, isEditOngoing: false };

        case REMOVE_ALL_PERSISTED_DATA:
            return _.cloneDeep(initialState);

        case SET_ALL_EQUIPMENTS_AND_PROFILE_ACCESSIBILITY:
            return { ...state, isLockedProfile: payload.lockedProfile, allEquipments: payload.equipments };

        case UPDATE_SENSOR_INFORMATION:
            updatedComponentInfo = _.cloneDeep(state.selectedComponent);
            updatedComponentInfo.sensors.forEach(sensor => {
                if(sensor.id === payload.id) {
                    sensor.metadata = payload.metadata
                    sensor.installLocation = payload.location
                    sensor.bearingInformation = payload.bearingInformation
                }
            });
            return { ...state, isEditOngoing: false, selectedComponent: updatedComponentInfo };

        case ADD_NEW_BEARING:
            updatedComponentInfo = _.cloneDeep(state.selectedComponent);
            let indexToDelete = -1;
            updatedComponentInfo?.bearings?.forEach((bearing, index) => {
                if (bearing.location === payload?.location) {
                    indexToDelete = index;
                }
            });
            if (indexToDelete >= 0) {
                updatedComponentInfo?.bearings?.splice(indexToDelete, 1);
            }
            updatedComponentInfo?.bearings?.push(payload);
            return { ...state, selectedComponent: updatedComponentInfo, componentLoading: false };

        case SET_EQUIPMENT_DETAIL_LOADING:
            return {
                ...state, equipmentLoading: payload, selectedComponent: {},
                currentEquipmentUnits: payload ? [] : state.currentEquipmentUnits
            };

        case SET_EQUIPMENTS:
            return { ...state, currentEquipmentUnits: payload.equipmentUnits,
            equipmentPictures: payload.equipmentPictures, equipmentLoading: false };

        case SET_ONGOING_EDIT_GLOBALLY:
            return { ...state, isEditOngoing: payload };

        case MAXIMIZE_OR_MINIMIZE_IMAGE_SECTION:
            return { ...state, currentEnlargedImageType: payload };

        case SET_SELECTED_COMPONENT_ID:
            return { ...state, selectedComponent: { id: payload } };

        case DESELECT_COMPONENT:
            return { ...state, selectedComponent: { id: "", equipmentUnitName: "", class: "", name: "", pictures: {} } };

        case UPDATE_COMPONENT_INFORMATION:
            return { ...state, selectedComponent: _.cloneDeep({ ...state.selectedComponent, metadata: payload }), isEditOngoing: false };

        case UPDATE_EQUIPMENT_UNIT_FOUNDATION:
            updatedComponentInfo = _.cloneDeep(state.currentEquipmentUnits);
            updatedComponentInfo[payload.name].foundation = payload.foundation;
            return { ...state, currentEquipmentUnits: updatedComponentInfo };

        case UPDATE_EQUIPMENT_UNIT_CLASS:
            updatedComponentInfo = _.cloneDeep(state.currentEquipmentUnits);
            updatedComponentInfo[payload.name].class = payload.class;
            return { ...state, currentEquipmentUnits: updatedComponentInfo };

        case SET_EQUIPMENT_UNIT_CLASSES_LIST:
            return { ...state, equipmentUnitClasses: payload };

        case UPDATE_CATEGORY_INFO:
            updatedEquipmentUnits = _.cloneDeep(state.currentEquipmentUnits);
            if(!_.isEmpty(payload?.softDeletedComponentNames) || !_.isEmpty(payload?.newComponents)) {
                let updatedComponentsList = [];
                updatedEquipmentUnits[payload.equipmentUnitName]?.components
                ?.filter(component => !payload.softDeletedComponentNames?.includes(component.name))
                .forEach(component => updatedComponentsList.push(component));

                if(!_.isEmpty(payload?.newComponents)) {
                    updatedComponentsList = [ ...updatedComponentsList, ...payload.newComponents ];
                }
                updatedEquipmentUnits[payload.equipmentUnitName].components = updatedComponentsList;
            }

            updatedEquipmentUnits[payload.equipmentUnitName].appliedCategoryName = payload.categoryName;

            updatedEquipmentsList = _.cloneDeep(state.allEquipments);
            for(let ind = 0; ind < updatedEquipmentsList.length; ind++) {
                if(updatedEquipmentsList[ind].id === payload.equipmentId) {
                    updatedEquipmentsList[ind].isCategoryNotAppliedEquipment = 
                        Object.values(updatedEquipmentUnits).filter(equipmentUnit => _.isEmpty(equipmentUnit.appliedCategoryName)).length > 0;
                }
            }
            return { ...state, currentEquipmentUnits: updatedEquipmentUnits, allEquipments: updatedEquipmentsList };

        case REMOVE_CATEGORY_FROM_EQUIPMENT_UNIT:
            updatedEquipmentUnits = returnUpdatedEquipmentUnitInfo(payload?.deletedComponentNames, payload?.restoredComponents);
            updatedEquipmentUnits[payload.equipmentUnitName].appliedCategoryName = "";

            updatedEquipmentsList = returnUpdatedEquipmentList(updatedEquipmentUnits);
            return { ...state, currentEquipmentUnits: updatedEquipmentUnits, allEquipments: updatedEquipmentsList };

        case UPDATE_EQUIPMENT_UNIT_NAME:
            updatedEquipmentUnits = {};
            Object.keys(state.currentEquipmentUnits).forEach((key) => {
                updatedEquipmentUnits[
                    state.currentEquipmentUnits[key].id === payload.id ?
                        payload.name
                            :
                        key
                ] = state.currentEquipmentUnits[key];
            });
            return { ...state, currentEquipmentUnits: updatedEquipmentUnits, isEditOngoing: false };

        case UPDATE_COMPONENT_NAME:
            updatedEquipmentUnits = _.cloneDeep(state.currentEquipmentUnits);

            Object.keys(updatedEquipmentUnits).forEach(equipmentUnit => {
                updatedEquipmentUnits[equipmentUnit].components.forEach(component => {
                    if(component.id === payload.id) {
                        component.name = payload.name;
                    }
                });
            });
            return { ...state, currentEquipmentUnits: updatedEquipmentUnits, isEditOngoing: false };

        case UPDATE_EQUIPMENT_UNIT_POSITIVE_DISPLACEMENT:
            updatedEquipmentUnits = _.cloneDeep(state.currentEquipmentUnits);
            updatedEquipmentUnits[payload.name].isPositiveDisplacement = payload.positiveDisplacement;
            return { ...state, currentEquipmentUnits: updatedEquipmentUnits, isEditOngoing: false };

        case REMOVE_BEARING:
            updatedComponentInfo = _.cloneDeep(state.selectedComponent);
            updatedComponentInfo.bearings = updatedComponentInfo?.bearings.filter(bearing => bearing.location !== payload);
            return { ...state, selectedComponent: updatedComponentInfo };

        default:
            return state;
    }
}

export default equipmentReducer